/**
 * Column header with sort indicator. Extracted from Products.jsx.
 */
import { ChevronDown, ChevronUp } from "lucide-react";

export function SortHeader({ children, sortKey, current, onChange, align = "left", testid }) {
  const active = current === sortKey;
  return (
    <th
      className={`py-2.5 px-3 font-medium text-[10px] uppercase tracking-wider ${align === "right" ? "text-right" : "text-left"}`}
    >
      <button
        type="button"
        onClick={() => onChange(sortKey)}
        data-testid={testid}
        className={`inline-flex items-center gap-1 hover:text-[var(--text-primary)] transition-colors ${active ? "text-[var(--accent)] font-semibold" : "text-[var(--text-muted)]"}`}
      >
        {children}
        {active ? (
          <ChevronDown size={11} className="opacity-80" />
        ) : (
          <ChevronUp size={11} className="opacity-30" />
        )}
      </button>
    </th>
  );
}
